module.exports = __webpack_public_path__ + "img/rede-2025-thumb.490d3227.jpg";